import { Box, Typography } from "@mui/material";
import React from 'react';

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    if (value !== index) {
        return null;
    }
    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            style={{ height: '100%' }}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            <Box style={{ height: '100%' }}>{children}</Box>
        </Typography>
    );
}

export default TabPanel